/* HOTFIX dead links (owner 30-Oct-2026) — EN + AR of the link texts whose target changed:
   formRenderer.fromRecordOpen / fromRecordSourceMateriality  the note on 105(a) sections 1, 2 and 4: there is no "Materiality
     page" — the figures are edited in the Materiality figures panel at the top of 105(a); the link scrolls there.
   w17_5.linkW16  the 505(r) Specific circumstances link opens form 211(a) Related parties (was "Open W16 — Related parties",
     which read as the Related-party worksheet, a different, audit-only screen). */
export default {
  en: {
    formRenderer: {
      fromRecordOpen: "Go to the materiality figures",
      fromRecordSourceMateriality: "materiality figures at the top of this form",
    },
    w17_5: {
      linkW16: "Open 211(a) — Related parties",
    },
  },
  ar: {
    formRenderer: {
      fromRecordOpen: "الانتقال إلى أرقام الأهمية النسبية",
      fromRecordSourceMateriality: "أرقام الأهمية النسبية أعلى هذا النموذج",
    },
    w17_5: {
      linkW16: "فتح ⁦211(a)⁩ — الأطراف ذوو العلاقة",
    },
  },
};
